import { render, staticRenderFns } from "./PagesDynamicSeoBlockWidget.vue?vue&type=template&id=58c711f8&"
import script from "./PagesDynamicSeoBlockWidget.vue?vue&type=script&lang=js&"
export * from "./PagesDynamicSeoBlockWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports